export const MainRoutes = {
    HOME: "/home",
    POLICY_STATUS_UPDATE: "/policy-status-update",
    POLICY_NUMBER_UPDATE: "/policy-number-update",
    PREV_POLICY_NUMBER_UPDATE: "/prev-policy-number-update",
    UPLOAD_SIGNATURE: "/upload-signatures",
    SECURITY_UTILITY: "/security-utility",
    FORM_UTILITY: "/form-utility",
    UPDATE_UNDER_WRITER: "/update-underwriter",
    LOA: "/loa/:sysId",
    UPDATE_DELETED_CLAIMS: "/ClaimsCoverageUpdate",
    UPDATE_CLAIM_NUMBER: "/ClaimsNumberUpdate",
    DATA_SCRIPT_APPROVAL: "/DataScriptApproval/:incidentNumber",
    DATA_SCRIPT_PP_APPROVAL: "/DataScriptApproval/:incidentNumber/:approvalTarget",
    UPDATE_INVOICE_STATUS: "/DataSriptRunUI",
    UPDATE_INVOICE_STATUS_PARAM: "/DataSriptRunUI/:incidentParam",    
    UPDATE_INVOICE_STATUS_PP_PARAM: "/DataSriptRunUI/:incidentParam/:approvalTarget",
};